module.exports = __webpack_public_path__ + "img/choose-up-gradinita.bb1af55b.png";